import { SourceTypeConfigHelper } from '../../create-pipeline/components/source-settings-form/config-helper';
import {
  getSelectorInclusionStateFromRawData,
  getSelectorRawDataFromInclusionState
} from '../../../../select/factories/singleLevelSelectorFactory';

export class TypeformConfigHelper implements SourceTypeConfigHelper {
  getConfigFromRawData(rawData: any) {
    return {
      selectedWorkspaces: getSelectorInclusionStateFromRawData(rawData)
    };
  }

  getDefaultConfig() {
  }

  buildConnectionParams(data: any) {
    return {
      ...getSelectorRawDataFromInclusionState(data.selectedWorkspaces)
    };
  }
}
